import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'i2g-context-menu-title-item',
  templateUrl: './context-menu-title-item.component.html',
  styleUrls: ['./context-menu-title-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuTitleItemComponent {
  @Input() title: string;
}
